module.exports = __webpack_public_path__ + "img/suit-02.39c4f1e2.png";